import licensesModalStyle from '../../css/licenses-modal.module.css';
import ConfirmationModalContainer from 'components/ConfirmationModalContainer';

import { useState, useEffect } from 'react';
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import AuthOrganizationService from "services/Auth.Organization.service";

import { cloneDeep, isNil } from "lodash";

const actions = {
  revoke: 'revoke',
  suspend: 'suspend',
  resume: 'resume',
};

const defaultContext = {
  title: '',
  description: '',
  status: false,
};

const actionList = {
  revoke: {
    value: 'revoke',
    title: '18bab10678',
    description: '24ce1c6c77',
    status: true,
  },
  suspend: {
    value: 'suspend',
    title: '62ac4db356',
    description: 'cf65d95481',
    status: true,
  },
  resume: {
    value: 'resume',
    title: '553e8a0372',
    description: 'b7af08d06f',
    status: true,
  },
};

const ActionsModal = ({
  modalStatus,
  cancelModal,
  submitModal,
  dataList
}) => {
  const { t } = useTranslation();
  const { pageContext } = useSelector((store) => store);
  const [context, setContext] = useState(cloneDeep(defaultContext));

  useEffect(() => {
    if (modalStatus.revoke.status) {
      setContext(actionList.revoke);
    } else if (modalStatus.suspend.status) {
      setContext(actionList.suspend);
    } else if (modalStatus.resume.status) {
      setContext(actionList.resume);
    } else {
      setContext(defaultContext);
    }
  }, [modalStatus]);

  const genSuspendList = () => {
    const list = [];
    for (const item of dataList) {
      if (item.isChecked) {
        list.push({
          organizationId: item.organizationId,
          licenseKey: item.licenseKey
        });
      }
    }
    return list;
  };

  const genRevokeList = () => {
    let obj = {};
    for (const item of dataList) {
      if (item.isChecked) {
        const orgId = item.organizationId;
        if (isNil(obj[orgId])) {
          obj[orgId] = {
            fromOrgId: orgId,
            toOrgId: pageContext.si.id,
            licenseKeys: []
          };
        }
        obj[orgId].licenseKeys.push(item.licenseKey);
      }
    }
    return obj;
  };

  const submit = async () => {
    if (context.value === actions.revoke) {
      const promises = [];
      const list = genRevokeList();
      for (const [key, data] of Object.entries(list))
        promises.push(await AuthOrganizationService.migrateBulkLicense(data));

      Promise.all(promises)
        .then((res) => {
          let result = [];
          for (const data of res)
            result = result.concat(data?.data);
          submitModal(result);
          cancelModal();
        });

    } else {
      const licenses = genSuspendList();
      const data = {
        action: context.value,
        licenses
      };
      const res = await AuthOrganizationService.suspendBulkLicense(data);
      if (res?.data) {
        submitModal(res?.data);
      } else {
        submitModal([{ error: res.error, licenseKey: '' }]);
      }
      cancelModal();
    }
  };

  return (
    <div className={licensesModalStyle['resume-modal']}>
      <ConfirmationModalContainer
        modalWidthType="modal-400px"
        title={t(context?.title)}
        description={t(context?.description)}
        openModal={context?.status}
        closeModal={() => cancelModal()}
        onConfirm={() => {
          submit();
        }}
      />
    </div>
  );
};

export default ActionsModal;